module.exports = __webpack_public_path__ + "static/plunker-4575cc87656d9db5d6b47fa598f39734.svg";